export function applyInitialVideoState(videoTrack, isCameraEnabled) {
    if (!isCameraEnabled && videoTrack?.mediaStreamTrack) {
        videoTrack.mediaStreamTrack.enabled = false;
    }
}
export async function finalizeInitialVideoState(videoTrack, shouldMute) {
    if (shouldMute) {
        await videoTrack.mute();
    }
}
